import React from "react";
import ZLaunchCoinInfoCard from "../../components/CoinInfoComponents/ZLaunchCoinInfoCard";

const ZLaunchCoinInfo = ({ coins }) => {
  return (
    <>
      {coins.nodes.map(
        (
          {
            excerpt,
            slug,
            acfCoinInfo: { ciIcon, ciHomeFullName, ciTickerSymbol },
          },
          i
        ) => (
          <ZLaunchCoinInfoCard
            key={`zlaunch-coin-card-item-${i}`}
            classNames="col-md-6 col-lg-4"
            linkTo={`/coin-info/${slug}/`}
            icon={ciIcon.localFile}
            title={`${ciHomeFullName} (${ciTickerSymbol})`}
            excerpt={excerpt}
          />
        )
      )}
    </>
  );
};

export default ZLaunchCoinInfo;
